import {useQuery} from 'react-query'
import {deleteTransport, fetchTransportList} from './api'
import {PageTitle} from '../../../_metronic/layout/core'
import {Error500} from '../../modules/errors/components/Error500'
import CRUDTable from '../../../components/table/CRUDTable'
import TransportAdminForm from './Form'
import toast, {Toaster} from 'react-hot-toast'
import DeleteButton from '../../../components/DeleteButton'
import ModalWithForm from '../../../components/ModalWithForm'
import EditBtn from '../../../components/EditBtn'
import {Button, Form} from 'react-bootstrap'
import viewProps from '../viewProps'
import {Processing} from '../../../components/Loaders'
import {Helmet} from 'react-helmet'
import {APIResponse} from '../../../types/type'
import {TransportAdminBase} from './type'
import ActivePill from '../../../components/ActivePill'
import InactivePill from '../../../components/InactivePill'
import {error} from 'console'
import message from 'react-intl/src/components/message'
import DeleteLabel from '../../../components/DeleteLabel'
import DeleteConfirmationModal from '../../../components/DeleteWarning'
import EditLabel from '../../../components/EditLabel'
import PortalDropdown from '../../../components/PortalDropdown'
import {deleteDivision} from '../division/api'
import DivisionForm from '../division/Form'
import TopBarProgress from 'react-topbar-progress-indicator'

const transportBreadcrumbs = [
  {
    title: 'User Management',
    path: 'users/transport-admin',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

function TransportAdmin() {
  const {data, isError, isFetching, isLoading, refetch} = useQuery<
    APIResponse<TransportAdminBase[]>
  >('transport', fetchTransportList, {
    refetchOnWindowFocus: false,
  })

  if (isLoading) {
    return <Processing />
  }
  const cellModifier = {
    transport_status: ({value}: {value: string}) => {
      switch (Number(value)) {
        case 1:
          return <ActivePill />
        case 0:
          return <InactivePill />
        default:
          return ''
      }
    },
    mobile: ({row}: {row: {original: TransportAdminBase}}) => {
      return `+${row.original.country_code} ${row.original.mobile}`
    },

    Actions: ({row}: {row: {original: TransportAdminBase}}) => {
      return (
        <PortalDropdown triggerProps={{className: 'btn btn-secondary px-0 py-1'}}>
          <span className="dropdown-item p-0">
            <ModalWithForm
              modalTitle={'Update Transport Admin User'}
              initialValues={row.original}
              onSubmit={refetch}
              Form={TransportAdminForm}
              modalAttrs={{size: 'sm'}}
              triggerClassName="d-block"
            >
              <EditLabel />
            </ModalWithForm>
          </span>
          <span className="dropdown-item p-0">
            <DeleteConfirmationModal
              triggerClassName="d-block"
              onDelete={async () => {
                const toastId = toast.loading('Deleting Please wait...')
                try {
                  const response = await deleteTransport(row.original.transport_id)
                  if (response?.status === false && response?.message) {
                    toast.error(response.message, {id: toastId})
                    return null
                  }
                  await refetch()
                  toast.success('Deleted Successfully', {id: toastId})
                } catch (error) {
                  toast.error('Something went wrong, please try again later', {id: toastId})
                }
              }}
            >
              <DeleteLabel />
            </DeleteConfirmationModal>
          </span>
        </PortalDropdown>
      )
    },
  }

  return (
    <>
      <Helmet>
        <title>TrackNAB | Transport Admin User</title>
      </Helmet>
      <PageTitle breadcrumbs={transportBreadcrumbs}>Transport Admin User</PageTitle>
      {isError ? (
        <div className="text-center">
          <Error500 />
        </div>
      ) : (
        <CRUDTable
          data={data?.data || []}
          {...viewProps.TransportAdmin}
          fieldToLabelMap={viewProps.TransportAdmin.primaryFieldsToLabelMap}
          Form={TransportAdminForm}
          formSize={{size: 'md'}}
          cellModifier={cellModifier}
          nonSortableColumns={['Actions']}
          headerExtras={
            <ModalWithForm
              modalTitle={'Add Transport Admin User'}
              triggerClassName="ms-auto"
              onSubmit={refetch}
              Form={TransportAdminForm}
              modalAttrs={{size: 'sm'}}
            >
              <Button size="sm">Add Transport Admin User</Button>
            </ModalWithForm>
          }
        />
      )}
      {isFetching && <TopBarProgress />}

      <Toaster />
    </>
  )
}

export default TransportAdmin
